export default __webpack_public_path__ + "static/media/play-content-completed.1a34ab04.svg";